module.exports = __webpack_public_path__ + "static/1308292157.93d95663.jpg";